namespace GeniuzPOS.ReportMasterData {
    export interface Report_1403Form {
    }

    export class Report_1403Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1403';
    }
}
